import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder.addCase(actionTypes.FETCH_USERS_WORKWEEK_CAPACITIES_SUCCESS, (state, action) => {
    const { response = {} } = action;
    return { ...state, ...response };
  });
  builder.addCase(actionTypes.EDIT_USERS_WORKWEEK_CAPACITIES_SUCCESS, (state, action) => {
    const { response = {} } = action;
    const { custom_weekly_worker_capacities = {} } = response;
    return { ...state, ...custom_weekly_worker_capacities };
  });
  builder.addMatcher(
    (action) => [actionTypes.FETCH_USER_WORKWEEK_SUCCESS, actionTypes.EDIT_USER_WORKWEEK_SUCCESS].includes(action.type),
    (state, action) => {
      const { response = {}, userId = 0 } = action;
      if (!userId) {
        return state;
      }
      return { ...state, [userId]: response };
    }
  );
});

export default reducer;
